import { LanguageSwitcher } from './LanguageSwitcher';

export const ConnectHeader = () => {
  return (
    <div className="max-w-2xl mx-auto mb-8">
      <div dir="ltr" className="flex justify-between items-center py-8 px-6 bg-gradient-to-r from-black to-gray-700 backdrop-blur-sm rounded-2xl border border-gray-700 shadow-xl">
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0">
            <img 
              src="/lovable-uploads/731a4d5a-546d-41f3-a979-93b9f45689bf.png" 
              alt="Shohnat" 
              className="h-10 w-auto" 
            />
          </div>
        </div>
        <LanguageSwitcher />
      </div>
    </div>
  );
};